import { render } from "./ScreenHeader.vue?vue&type=template&id=9a2a0886&scoped=true"
import script from "./ScreenHeader.vue?vue&type=script&lang=js"
export * from "./ScreenHeader.vue?vue&type=script&lang=js"

import "./ScreenHeader.vue?vue&type=style&index=0&id=9a2a0886&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2a0886"]])

export default __exports__